import { ReferenceInput, SelectInput } from 'react-admin';

const CustomReferenceInput = ({ source, label, reference }) => (
  <ReferenceInput
    sort={{ field: 'name', order: 'ASC' }}
    resource={reference}
    label={label}
    source={source}
    reference={reference}
    perPage={-1}
  >
    <SelectInput label={label} optionText="name" optionValue="id" />
  </ReferenceInput>
);

export default CustomReferenceInput;
